<textarea
  nz-input
  [name]="config.name"
  [placeholder]="config.placeholder"
  [(ngModel)]="config.value"
  (ngModelChange)="onChange($event)"
  [nzAutosize]="config.autosize"
  [required]="config.required"
  [disabled]="config.disabled"
  style="height: 107px; min-height: 107px"
></textarea>
